"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Button = exports.Anchor = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const Button = exports.Button = _styledComponents.default.button`
  background: transparent;
  padding: 0;
  margin: 0;
  display: inline;
  border: none;
  cursor: pointer;
  color: inherit;
  font-family: inherit;
  font-size: inherit;
`;

// Todo: we can't use inherit font family or size here because of poor typography inheritance rules.
const Anchor = exports.Anchor = _styledComponents.default.a`
  color: inherit;
  text-underline-offset: 2px;
`;
var _default = exports.default = {};